<div class="rv-grid small">
  <div class="rv-column-12">
    <div class="track-wrapper">
      <div
        class="track"
        (clientSize)="trackWidth = $event.width"
        *ngLet="getScale() as scale"
      >
        <div
          class="value"
          [style.left.%]="getLowerInRange()"
          [style.width.%]="getWidthInRange()"
        ></div>
        <div
          class="handle lower"
          [class.dragging]="lowerDragStart !== null"
          [style.left.%]="getLowerInRange()"
          (mousedown)="lowerDragStart = [value[0], $event.clientX]"
        ></div>
        <div
          class="handle upper"
          [class.dragging]="upperDragStart !== null"
          [style.left.%]="getUpperInRange()"
          (mousedown)="upperDragStart = [value[1], $event.clientX]"
        ></div>
      </div>
    </div>
  </div>
  <div class="manual-range" [ngSwitch]="type">
    <ng-container *ngSwitchCase="'number'">
      <deprecated-text-field
        [type]="'number'"
        [min]="lowerMin"
        [max]="getEffectiveLowerMax()"
        [ngModel]="value[0].toString()"
        (ngModelChange)="value = [+$event, value[1]]"
      ></deprecated-text-field>
      <span>&ndash;</span>
      <deprecated-text-field
        [type]="'number'"
        [min]="getEffectiveUpperMin()"
        [max]="upperMax"
        [ngModel]="value[1].toString()"
        (ngModelChange)="value = [value[0], +$event]"
      ></deprecated-text-field>
    </ng-container>
    <ng-container *ngSwitchCase="'currency'">
      <riv-currency-field
        [min]="lowerMin"
        [max]="getEffectiveLowerMax()"
        [value]="value[0]"
        (valueChange)="value = [$event, value[1]]"
      ></riv-currency-field>
      <span>&ndash;</span>
      <riv-currency-field
        [min]="getEffectiveUpperMin()"
        [max]="upperMax"
        [value]="value[1]"
        (valueChange)="value = [value[0], $event]"
      ></riv-currency-field>
    </ng-container>
    <ng-container *ngSwitchCase="'percent'">
      <riv-percentage-field
        [min]="lowerMin"
        [max]="getEffectiveLowerMax()"
        [value]="value[0]"
        (valueChange)="value = [$event, value[1]]"
      ></riv-percentage-field>
      <span>&ndash;</span>
      <riv-percentage-field
        [min]="getEffectiveUpperMin()"
        [max]="upperMax"
        [value]="value[1]"
        (valueChange)="value = [value[0], $event]"
      ></riv-percentage-field>
    </ng-container>
  </div>
</div>
